export const getVh = (percentage: number) =>
    `calc(var(--app-height) * ${percentage})`;
